import { render, staticRenderFns } from "./BrTypeCountPie.vue?vue&type=template&id=381a8d06&scoped=true"
import script from "./BrTypeCountPie.vue?vue&type=script&lang=js"
export * from "./BrTypeCountPie.vue?vue&type=script&lang=js"
import style0 from "./BrTypeCountPie.vue?vue&type=style&index=0&id=381a8d06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a8d06",
  null
  
)

export default component.exports